var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ATTACHED_MARKER = "horaPhoneValidator";
const HINT_CLASS = "hora-phone-hint";
const HINT_TONE = {
    error: "hora-phone-hint--error",
};
const REASON_MESSAGES = {
    invalid_format: "Please enter a valid phone number, including the country code.",
    invalid_number: "This phone number is not valid. Please double-check the digits.",
};
const VALIDATING_LABEL = "Validating";
export function attachPhoneValidator(input, opts) {
    if (input.dataset[ATTACHED_MARKER] === "1") {
        return;
    }
    input.dataset[ATTACHED_MARKER] = "1";
    let abortController = null;
    const clearHint = () => {
        const existing = findHint(input);
        if (existing)
            existing.remove();
    };
    const appendHint = (hint) => {
        const container = getHintContainer(input);
        container.appendChild(hint);
    };
    const renderError = (reason) => {
        var _a;
        clearHint();
        if (reason === "empty")
            return;
        const message = ((_a = opts.i18n) === null || _a === void 0 ? void 0 : _a[`phone_${reason}`]) || REASON_MESSAGES[reason];
        if (!message)
            return;
        const hint = document.createElement("div");
        hint.className = `${HINT_CLASS} ${HINT_TONE.error}`;
        hint.setAttribute("role", "alert");
        hint.textContent = message;
        appendHint(hint);
    };
    const showSpinner = () => {
        var _a;
        clearHint();
        const hint = document.createElement("div");
        hint.className = `${HINT_CLASS} hora-phone-hint--loading`;
        const spinner = document.createElement("span");
        spinner.className = "hora-spinner";
        spinner.setAttribute("role", "status");
        spinner.setAttribute("aria-label", ((_a = opts.i18n) === null || _a === void 0 ? void 0 : _a.validating) || VALIDATING_LABEL);
        hint.appendChild(spinner);
        appendHint(hint);
    };
    const resolveCountry = () => {
        var _a;
        const iti = getItiInstance(input);
        const fromIti = (_a = iti === null || iti === void 0 ? void 0 : iti.getSelectedCountryData) === null || _a === void 0 ? void 0 : _a.call(iti).iso2;
        if (fromIti)
            return fromIti.toUpperCase();
        const fromAttr = input.getAttribute("data-initial-country");
        return fromAttr ? fromAttr.toUpperCase() : undefined;
    };
    const runValidation = () => __awaiter(this, void 0, void 0, function* () {
        const phone = input.value.trim();
        if (phone === "") {
            clearHint();
            return;
        }
        abortController === null || abortController === void 0 ? void 0 : abortController.abort();
        abortController = new AbortController();
        showSpinner();
        try {
            const body = { phone };
            const country = resolveCountry();
            if (country)
                body.country = country;
            const response = yield fetch(`${opts.restUrl.replace(/\/$/, "")}/validate-phone`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-WP-Nonce": opts.nonce,
                },
                body: JSON.stringify(body),
                signal: abortController.signal,
                credentials: "same-origin",
            });
            if (!response.ok) {
                clearHint();
                return;
            }
            const result = yield response.json();
            if (result.valid) {
                clearHint();
                return;
            }
            if (result.reason) {
                renderError(result.reason);
            }
            else {
                clearHint();
            }
        }
        catch (err) {
            if ((err === null || err === void 0 ? void 0 : err.name) === "AbortError")
                return;
            clearHint();
            console.warn("Phone validation request failed", err);
        }
    });
    input.addEventListener("blur", runValidation);
    input.addEventListener("change", runValidation);
}
function findHint(input) {
    return getHintContainer(input).querySelector(`.${HINT_CLASS}`);
}
function getHintContainer(input) {
    var _a, _b;
    return (_b = (_a = input.closest(".hora-form-field")) !== null && _a !== void 0 ? _a : input.parentElement) !== null && _b !== void 0 ? _b : input;
}
function getItiInstance(input) {
    const candidate = input.itiInstance;
    return candidate !== null && candidate !== void 0 ? candidate : null;
}
export function attachPhoneValidatorToForm(root, opts) {
    root
        .querySelectorAll("input.hora-phone-input")
        .forEach((input) => attachPhoneValidator(input, opts));
}
